import {
  DefaultApi,
  GetStageDefinitionDto,
  GetStageDefinitionWithStatusDto,
} from '../autogenerated/pokApiClient';

export interface StageDefinitionContextInterface {
  getStagesForProject: (
    projectId: string,
    month?: Date,
  ) => Promise<GetStageDefinitionWithStatusDto[]>;
  getAll: () => Promise<GetStageDefinitionDto[]>;
}

export const StageDefinitionContext = (api: DefaultApi) => {
  return {
    getStagesForProject: (projectId: string, month?: Date) =>
      api.stageDefinitionControllerGetStagesForProject(projectId, month),
    getAll: () => api.stageDefinitionControllerGetAllActiveStages(),
  };
};
